import { ActivationType } from "@humanex/interfaces";
import { getErrorMessage, toast } from "@humanex/ui/libs";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { accountApiClient } from "@/libs/api";

export const activationKeys = {
  all: ["activation"] as const,
  status: () => [...activationKeys.all, "status"] as const
};

export function useActivationStatus(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: activationKeys.status(),
    queryFn: () => accountApiClient.getStatus(ActivationType.AGENT),
    enabled: options.enabled ?? true,
    staleTime: 60 * 1000
  });
}

export function useRequestActivation(options: { onSuccess?: (checkoutUrl: string) => void } = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => accountApiClient.requestActivation(ActivationType.AGENT),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: activationKeys.status() });
      options.onSuccess?.(data.checkoutUrl);
    },
    onError: (error: unknown) => {
      toast.error(getErrorMessage(error) || "Có lỗi xảy ra, vui lòng thử lại.");
    }
  });
}
